/**
 * custom.js — store-specific behavior, intentionally jQuery-free.
 *
 * The Trustpilot slider init that used to live here moved into
 * sections/trustpilot-review.liquid, so this file no longer needs jQuery
 * and can run on every page without pulling in extra libraries.
 */

document.addEventListener('DOMContentLoaded', function () {
  // On mobile, move the review details block directly below the add-to-cart
  // button. Runs once per matchMedia change instead of on every resize event.
  var mobileQuery = window.matchMedia('(max-width: 767px)');

  function reorderReviewDetails() {
    if (!mobileQuery.matches) return;
    var reviewDetails = document.querySelector('.review_details');
    var atcButton = document.querySelector('.atc-buuton');
    if (reviewDetails && atcButton) {
      atcButton.insertAdjacentElement('afterend', reviewDetails);
    }
  }

  reorderReviewDetails();
  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', reorderReviewDetails);
  }

  // Simple tab switcher for .custom-tabs blocks.
  document.querySelectorAll('.tab-btn').forEach(function (tab) {
    tab.addEventListener('click', function () {
      var wrapper = this.closest('.custom-tabs');
      if (!wrapper) return;

      wrapper.querySelectorAll('.tab-btn').forEach(function (btn) {
        btn.classList.remove('active');
      });
      wrapper.querySelectorAll('.tab-content').forEach(function (content) {
        content.classList.remove('active');
      });

      this.classList.add('active');
      var target = document.getElementById(this.dataset.tab);
      if (target) {
        target.classList.add('active');
      }
    });
  });
});
